import { render, staticRenderFns } from "./SlideList.vue?vue&type=template&id=a6c003bc&scoped=true&"
import script from "./SlideList.vue?vue&type=script&lang=js&"
export * from "./SlideList.vue?vue&type=script&lang=js&"
import style0 from "./SlideList.vue?vue&type=style&index=0&id=a6c003bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c003bc",
  null
  
)

export default component.exports